import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DFA from '@nykaa/cart-shared/wrapper/DFA';
import { deviceTypes, ORIGIN_SOURCE } from '@nykaa/cart-shared/constants';
import { setToastMessage } from '@nykaa/cart-shared/store/action';
import {
  addItemToCart,
  getDFAProducts,
} from '@nykaa/cart-shared/store/service';
import { EDD_EXPERIEMENT_HEADER } from '@nykaa/cart-shared/store/constants';
import { logger } from '@nykaa/logger';
import { State } from 'store/types';

interface DFAProductsProps {
  fetchCartInfo: () => void;
  isConvenienceFeeEnabled?: boolean;
}

const DFAWidget = ({
  fetchCartInfo,
  isConvenienceFeeEnabled,
}: DFAProductsProps) => {
  const dispatch = useDispatch();
  const { items, shippingDataDTO, cartPriceDTO, pincode } = useSelector(
    (state: State) => state.cartReducer.cartInfo
  );
  const [dfaProductsList, setDFAProductList] = useState({
    products: [],
  });
  const eddWidget =
    useSelector((state: State) => state.remoteConfig.switches?.cartEddWidget) ||
    false;

  const loadDFAProducts = async () => {
    const params = {
      deviceType: deviceTypes.DESKTOP,
      ids: items.map((x) => x.productId).join(','),
      pincode: pincode,
      originSource: ORIGIN_SOURCE.CART,
      headers: { [EDD_EXPERIEMENT_HEADER]: eddWidget },
      domain: __PLATFORM__,
      catalog_tag_filter: __PLATFORM__,
    };

    try {
      const data = await getDFAProducts(params);
      if (data) {
        setDFAProductList(data);
      }
    } catch (err) {
      logger.error(err as Error, 'Error while fetching dfa products');
    }
  };
  useEffect(() => {
    if (items?.length) {
      loadDFAProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  const handleAddToBag = async (productId: string) => {
    const params = {
      deviceType: deviceTypes.DESKTOP,
      domain: __PLATFORM__,
      catalog_tag_filter: __PLATFORM__,
      pro: true,
      items: [
        {
          productId: productId,
          quantity: 1,
        },
      ],
      pincode,
      originSource: ORIGIN_SOURCE.CART,
      headers: { [EDD_EXPERIEMENT_HEADER]: eddWidget },
    };
    try {
      const data = await addItemToCart(params, isConvenienceFeeEnabled);
      if (data) {
        fetchCartInfo();
      }
    } catch (err) {
      setToastMessage(err?.message || 'Something Went Wrong!')(dispatch);
      logger.error(err as Error, 'Error while adding item to bag');
    }
  };

  const config: any = {
    products: dfaProductsList?.products || [],
    shippingDataDTO,
    cartPriceDTO,
    handleAddToBag,
  };

  return <DFA {...config} />;
};

export default DFAWidget;
